export default __webpack_public_path__ + "75af4655fcf546b8191d7b47112d1175.svg";